module.exports = __webpack_public_path__ + "img/form-left.0981c5de.png";